export const colors = [
  {
    name: 'Silver',
    color: 'silver',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/silver_d0b207d7-bac9-4615-8e4a-5d1bcd7cfaf5.jpg'
      }
    ]
  },
  {
    name: 'Blue',
    color: 'blue',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/blue_f863b6e9-643e-425d-894f-ded8778c9e89.jpg'
      }
    ]
  }
];
